import type { NetworkData } from '@dynamic-labs-sdk/client';
import { createBaseNetworkProvider } from '@dynamic-labs-sdk/client/core';

import type { AptosNetworkProvider } from '../../AptosNetworkProvider.types';
import { fetchAptosBalance } from '../fetchAptosBalance';

export const createAptosNetworkProvider = (
  networkData: NetworkData
): AptosNetworkProvider => ({
  ...createBaseNetworkProvider('APTOS', networkData),
  cluster: networkData.cluster,
  getBalance: async ({ address }) => ({
    balance: await fetchAptosBalance({
      address,
      networkData,
    }),
  }),
});
